/**
 * Configuration du Concours de Parrainage
 *
 * TOUTES les paramètres du concours sont ici pour une modification facile
 */
export const CONTEST_CONFIG = {
  // Date de début du concours (format ISO 8601)
  // Seuls les parrainages et dépôts après cette date sont comptabilisés
  START_DATE: '2026-03-20T00:00:00Z',

  // Date de fin du concours (format ISO 8601)
  // Modifiez cette date pour changer la fin du concours
  END_DATE: '2026-04-30T00:00:00Z',

  // Objectif : nombre de parrainages valides requis pour gagner
  TARGET_REFERRALS: 300,

  // Prix du concours (en FCFA)
  PRIZE_AMOUNT: 100000,

  // Seuil cumulatif de dépôts requis pour valider un parrainage
  // Un parrainage devient valide quand le parrainé a accumulé ce montant total
  DEPOSIT_THRESHOLD: 100,

  // Identifiant unique du concours (pour support multi-concours)
  CONTEST_ID: 'contest-2026',

  // URL de base pour les liens de parrainage
  REFERRAL_LINK_BASE: `${window.location.origin}`,

  // Participants exclus manuellement du classement (tricheurs, influenceurs, etc.)
  // Ajouter les numero_commercial à exclure : ex. ['influencer123', 'tricheur456']
  EXCLUDED_PARTICIPANTS: [] as string[],
} as const;

/**
 * Génère un lien de parrainage pour un utilisateur
 */
export function generateReferralLink(userId: string): string {
  return `https://${userId}.easyservicebf.com`;
}

/**
 * Vérifie si le concours est toujours actif
 */
export function isContestActive(): boolean {
  return new Date(CONTEST_CONFIG.END_DATE) > new Date();
}

/**
 * Calcule le temps restant jusqu'à la fin du concours
 */
export function getTimeRemaining(): {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  isExpired: boolean;
} {
  const now = new Date();
  const end = new Date(CONTEST_CONFIG.END_DATE);
  const diff = end.getTime() - now.getTime();

  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, isExpired: true };
  }

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds, isExpired: false };
}
